import { AfterContentChecked, ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { AuthenticationService } from '../core/services/authentication.service';
import { RouteBean } from './model/RouteBean';
import { AdministrationService } from './services/route-service';
import { NgbPagination } from '@ng-bootstrap/ng-bootstrap';
import { FilterMetadata, SortEvent } from 'primeng/api';
import { Table } from 'primeng/table';
import { SessionStorageService } from './services/session-storage.service';

@Component({
  selector: 'app-route-master',
  templateUrl: './route-master.component.html',
  styleUrls: ['./route-master.component.css']
})
export class RouteMasterComponent implements AfterContentChecked {
  @ViewChild('paginationRoute') paginationRoute!: NgbPagination;
  @ViewChild('dt') dt!: Table;

  administration: RouteBean[];
  allAdministration: RouteBean[];
  allAdministrationStable: RouteBean[];
  validFromDateMap = new Map<string, Date>();
  validToDateMap = new Map<string, Date>();
  newInref: boolean;
  changedDate: string;
  tableName: string = 'inRefTable';
  sortField: string;
  sortOrder: number;
  infRef: RouteBean;
  canChangePage: boolean;
  editInref: boolean;
  isLoading: boolean = true;
  isUsersystemEmpty: boolean = false;
  userSystemMessage: string='';
  chnagePage = false;

  totalRecords: number;
  currentPage = 1;
  rowsPerPage = 15;
  currentSort: SortEvent;
  dataInitialized: boolean = false;

  constructor(
    private adminService: AdministrationService,
    private authenticationService: AuthenticationService,
    private cdr: ChangeDetectorRef,
    private sessionStorageService: SessionStorageService
  ) { }
  
  ngOnInit() {
   this.isLoading = true; 

   this.sortField = 'title';
    this.sortOrder = 1;
    if (sessionStorage.getItem(this.tableName)) {
      let tableStorage = JSON.parse(sessionStorage.getItem(this.tableName) + "");
      this.sortField = tableStorage.sortField
        ? tableStorage.sortField
        : this.sortField;
      this.sortOrder = tableStorage.sortOrder
        ? tableStorage.sortOrder
        : this.sortOrder;
    }
    //Warning message for empty userSystems
    this.adminService.getuserSystems().then(data => {
      if(data && data.length>0)
      {
        this.isUsersystemEmpty = false;
      }
      else 
      {
        this.isUsersystemEmpty = true;
        this.userSystemMessage = "Der er ingen it-systemer, der har en aktiv serviceaftale på Fordelingskomponenten med din kommune, og det er derfor ikke muligt at oprette fordelingsregler.";
      }
     });
      this.adminService.getAdministration().then((data) => {
      if(data)
      {
        const data1 = data.map(d=>{
          const x: any={}
          x.id = d.id;
          x.title = d.title;
          x.kleEmne = d.kleEmne;
          x.handlingFacet = d.handlingFacet;
          x.channelType = d.channelType;
          x.systemUUID = d.systemUUID;
          x.systemName = d.systemName;
          x.endPointURI = d.endPointURI;
          x.endpointUUID = d.endpointUUID;
          x.validFrom = d.validFrom;
          x.validTo = d.validTo;
          x.cvr = d.cvr;
          x.changedDate = d.changedDate;
          x.changedBy = d.changedBy;
          x.validFromSort = this.formatDate(d.validFrom);
          x.validToSort = this.formatDate(d.validTo);
          this.changedDate = this.formatDate(d.changedDate);
          this.validFromDateMap.set(d.id,new Date(x.validFrom));
          this.validToDateMap.set(d.id,new Date(x.validTo));
          return x;
        });
        this.allAdministration = data1;
        this.allAdministrationStable = data1;
        this.totalRecords = data1.length;
        if (this.showPagination) {
          const firstItemIndex = (this.currentPage - 1) * this.rowsPerPage;
          this.administration = this.allAdministration.slice(firstItemIndex, firstItemIndex + this.rowsPerPage);
          
        }
        else {
          this.administration = data1;
        }
  
        this.dataInitialized = true;
        this.cdr.detectChanges();
          this.isLoading = false; 
      }
    });
  }

  ngAfterContentChecked(): void {
    if (this.dataInitialized && this.dt?.value) {
      this.dataInitialized = false;
      this.inputChange("", "");
      this.initPagination();
    }
  }

  onNyInref() {
    this.infRef = {};
    this.newInref = true;
  }

  onRowSelect(event: any) {
    this.infRef = event.data; 
    event.data.validFrom = this.validFromDateMap.get(this.infRef.id as string);
    event.data.validTo = this.validToDateMap.get(this.infRef.id as string);
    this.editInref = true;
  }

  editCancel() {
    this.editInref = false;
    this.newInref = false;
    this.ngOnInit();
  }

  editSubmit() {
    this.ngOnInit();
    this.editInref = false;
    this.newInref = false;
  }  

  isEnable()
  {
    return this.authenticationService.canUserEdit();
  }

  formatDate(dateString: string)
  {
     return String(new Date(dateString as string).getDate()).padStart(2,'0')
        +'/'+String(new Date(dateString as string).getMonth() + 1).padStart(2, '0')+'/'+new Date(dateString as string).getFullYear();
  }

  onPageChange(pageNumber: number) {
    this.savePagination(pageNumber);
    this.currentPage = pageNumber;
    this.administration = this.allAdministration.slice((pageNumber - 1) * this.rowsPerPage,
      (pageNumber - 1) * this.rowsPerPage + this.rowsPerPage);
  }

  get showPagination(): any {
    return this.rowsPerPage && (this.rowsPerPage > 0) && (this.allAdministration?.length > this.rowsPerPage);
  }

  customSort(event: SortEvent) {
    if (!this.currentSort) {
      this.currentSort = event;
    }

    let property = event.field as keyof RouteBean;

    if (property) {

      this.allAdministration.sort((data1: any, data2: any) => {
        let value1 = data1[property];
        let value2 = data2[property];
        let result = null;

        let newOrder = event.order ? event.order : 0;

        result = value1?.toString().localeCompare(value2?.toString());

        return (newOrder * result);
      })
    }

    if(this.allAdministration?.length < this.rowsPerPage) {
      this.administration = this.allAdministration.slice(0, this.rowsPerPage);
    }

    if (this.currentSort.field !== event.field || this.currentSort.order !== event.order) {
      this.paginationRoute?.pageChange?.emit(1);
      if(this.paginationRoute) {
        this.paginationRoute.page = 1;
      }
      
      this.currentSort = event;
    }

    if(this.paginationRoute) {
      this.paginationRoute.page = 1;
    }

  }

  inputChange(inputValue: string, field: string) {
    if (this.allAdministration) {
      let filters = Object.entries(this.dt.filters).map((e) => ({ [e[0]]: e[1] }));
      if (field && filters) {
        for (const filter of filters) {
          if (filter[field] != null) {
            this.dt.filters[field] = {
              value: inputValue,
              matchMode: "contains"
            }
          } else {
            this.dt.filters[field] = {
              value: inputValue,
              matchMode: "contains"
            }
          }
        }
      } else {
        this.dt.filters[field] = {
          value: inputValue,
          matchMode: "contains"
        }
      }

      filters = Object.entries(this.dt.filters).map((e) => ({ [e[0]]: e[1] }));

      this.allAdministration = this.allAdministrationStable;

      for (const f of filters) {
        let property = Object.keys(f).at(0) as keyof RouteBean;
        let filterMetadata = f[property] as FilterMetadata;
        if (filterMetadata.value) {
          this.allAdministration = this.allAdministration.filter(data => data[property]?.toString().toLowerCase().includes(filterMetadata.value.toLowerCase()));
        }
      }
      this.totalRecords = this.allAdministration.length;
      if (this.allAdministration?.length > 0) {
        this.paginationRoute?.pageChange?.emit(1);
        this.currentPage = 1;
        if(!this.paginationRoute) {
          this.onPageChange(1);
        } else {
          this.paginationRoute.page = 1;
        }
      }
    }

  }


  
  private savePagination(page: number) {
    this.sessionStorageService.put(this.sessionStorageService.ROUTE_MASTER_PAGINATION, page);
  }

  private initPagination() {
    let page = this.sessionStorageService.get(this.sessionStorageService.ROUTE_MASTER_PAGINATION);
    if (this.paginationRoute?.pageCount < page) {
      this.paginationRoute?.pageChange?.emit(this.paginationRoute.pageCount);
      if (this.paginationRoute) {
        this.paginationRoute.page = this.paginationRoute.pageCount;
      }
    } else {
      this.paginationRoute?.pageChange?.emit(page);
      if (this.paginationRoute) {
        this.paginationRoute.page = page;
      }
    }
  }

}